module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "pix"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])]), _c('a', {
    attrs: {
      "id": "pix"
    }
  }, [_c('table', {
    attrs: {
      "width": "70%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgements"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_c('i', [_vm._v("Introduction")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_vm._v("Marriage Models")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Glance Back")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Beauty of Submission")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter003a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kathy O’Sullivan’s Story")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacrificial Love")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeff and Bonnie")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus, the One Who Bonds the Two")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greg and Tracey")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sanctuary")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Come Away, My Lover")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choose the Better Way")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/a_prayer",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A Prayer for Marriages")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/abo_aut",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 75
// module chunks = 0